/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 01/02/2018.
*
* top-bar Component
*/
<template>
  <el-col class="top-bar">
    <el-row>
      <el-col :span="14">
        <div class="title-content">
          <div class="wrapper">
            <h1>{{ title }}</h1>
            <h2 v-if="subtitle">{{ subtitle }}</h2>
          </div>
        </div>
      </el-col>
      <el-col
        :span="10"
        class="text-right"
      >
        <slot/>
        <el-button
          v-if="showAddButton"
          type="primary"
          class="button-add"
          @click="$emit('addItem')"
        >
          <i class="icon-add"/> {{ addButtonLabel }}
        </el-button>
      </el-col>
    </el-row>
  </el-col>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  name: 'TopBar',
  props: {
    title: {
      type: String,
      required: true,
      default: 'Component Title'
    },
    subtitle: {
      type: String,
      default: '',
      required: false
    },
    showAddButton: {
      type: Boolean,
      default: false,
      required: false
    },
    addButtonLabel: {
      type: String,
      default: 'Nuevo',
      required: false
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
  .top-bar {
    background-color: #fff;
    border-bottom: #dddddd;
    box-shadow: 0 2px 10px -2px rgba(0, 0, 0, 0.15);
    height: 80px;
    position: relative;
    z-index: 1;
    .title-content {
      height: 80px;
      margin-left: 20px;
      display: flex;
      align-items: center;
      h1 {
        @include font-primary(18px, bold);
        text-transform: uppercase;
        margin: 0;
      }
      h2 {
        @include font-primary(14px, light);
        margin: 3px 0 0 0;
      }
    }
    .button-add {
      margin-top: 20px;
      margin-right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/top-bar.vue